import { render, staticRenderFns } from "./RushInfo.vue?vue&type=template&id=07c72d5d&"
import script from "./RushInfo.vue?vue&type=script&lang=js&"
export * from "./RushInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports